import { useState } from 'react';
import { generateError } from '@dx-ui/utilities-generate-error';
import { logError } from '@dx-ui/framework-logger';
import type { LoginFormResponse } from '../login-form/login-form.types';

export type FormData = {
  username: string;
  password: string;
};

type UseTwoFactorReturn = {
  submitOTPCode: (
    sourceId: string,
    totp: string,
    formData: FormData,
    partner?: boolean
  ) => Promise<LoginFormResponse | null>;

  loading: boolean;
};

const useTwoFactor = (): UseTwoFactorReturn => {
  const [loading, setLoading] = useState(false);

  const submitOTPCode = async (
    sourceId: string,
    totp: string,
    formData: FormData,
    partner?: boolean
  ): Promise<LoginFormResponse | null> => {
    setLoading(true);

    try {
      const postOptions: RequestInit = {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ ...formData, totp, ...(partner ? { partner } : {}) }),
      };

      const response = await fetch(`/en/auth2/api/guest/login/${sourceId}/verify`, postOptions);

      return await response.json();
    } catch (error) {
      const safeError = generateError(error);
      logError('LOGIN_FORM_OTP', safeError);
      return Promise.reject(safeError);
    } finally {
      setLoading(false);
    }
  };

  return { submitOTPCode, loading };
};

export default useTwoFactor;
